module.exports = __webpack_public_path__ + "static/img/interface.c7bc88d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trackplus_2021/interface.png
// module id = K4Wy
// module chunks = 1